import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LegalPage({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-12">
        <div className="text-xs uppercase tracking-widest text-brand-blue font-semibold">Policy</div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight mt-1">{title}</h1>
        {lastUpdated && (
          <div className="text-xs text-muted-foreground mt-2">Last updated: {lastUpdated}</div>
        )}
        <article className="prose prose-sm sm:prose-base dark:prose-invert mt-8 max-w-none
          [&>h2]:font-bold [&>h2]:text-xl [&>h2]:mt-8 [&>h2]:mb-3
          [&>h3]:font-semibold [&>h3]:text-base [&>h3]:mt-6 [&>h3]:mb-2
          [&>p]:text-sm [&>p]:leading-relaxed [&>p]:text-foreground/85 [&>p]:mb-3
          [&>ul]:list-disc [&>ul]:pl-5 [&>ul]:text-sm [&>ul]:space-y-1 [&>ul]:mb-3
          [&>ol]:list-decimal [&>ol]:pl-5 [&>ol]:text-sm [&>ol]:space-y-1 [&>ol]:mb-3
          [&_strong]:text-foreground">
          {children}
        </article>
        <div className="mt-12 p-4 rounded-lg border border-border bg-muted/40 text-xs text-muted-foreground">
          For any questions about this policy, contact <a href="mailto:keltastate@gmail.com" className="text-brand-blue font-medium">keltastate@gmail.com</a> or write to KELTA Office, M.P Building, 12/79 D, Vellalassery P.O, N.I.T Via, Kozhikode – 673601.
        </div>
      </main>
      <Footer />
    </div>
  );
}
